import React from "react";
import type { InputProps } from "@mui/joy";
import { Input } from "@mui/joy";
import { colorTokens, ctaAccentColor, textTokens } from "../../styles/globalStyles";

/**
 * Dark-themed Input component with consistent styling across the app
 */
const DarkInput = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { sx, ...other } = props;

  const darkInputStyles = {
    backgroundColor: colorTokens.bg.surfaceMuted,
    color: textTokens.color.primary,
    borderRadius: "8px",
    border: `1px solid ${colorTokens.border.default}`,
    "&:hover": {
      borderColor: ctaAccentColor,
    },
    "&:focus-within": {
      borderColor: ctaAccentColor,
    },
    "& input": {
      color: textTokens.color.primary,
    },
    "& input::placeholder": {
      color: textTokens.color.placeholder,
      opacity: 1,
    },
    ...sx,
  };

  return <Input ref={ref} sx={darkInputStyles} {...other} />;
});

DarkInput.displayName = "DarkInput";

export default DarkInput;
